
import axios from "axios";

export const setupUser = (accessToken, tokenType) => {
    return new Promise((resolve, reject) => {
        try {
            axios.get("https://discord.com/api/users/@me/guilds/939623519237599264/member", {
                headers: {
                    authorization: `${tokenType} ${accessToken}`
                }
                })
                .then(response => {
                    if (response && response.data) {

                        var role = getUserRole(response.data.roles);

                        if (role) {

                            let user = {
                                tokenType: tokenType,
                                accessToken: accessToken,
                                id: response.data.user.id,
                                name: response.data.nick,
                                username: response.data.user.username,
                                role: role.name,
                                isOwner: role.isOwner,
                                isAdmin: role.isAdmin,
                                date: new Date()
                            }

                            // store the user in localStorage
                            localStorage.removeItem('guilds');
                            localStorage.setItem('user', JSON.stringify(user));
                            resolve();
                        }
                        else
                            reject("User does not have correct role to login");
                    }
                    else {
                        reject("No Response received");
                    }
                }).catch(error => {
                    reject(error.message);
                })
        } catch (err) {
            reject(err.message);
        }
    });
}

export const getUserName = () => {
    var name;
    let loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
        let parsedUser = JSON.parse(loggedInUser);
        name = parsedUser.name;
    }
    return name;
}

export const getUser = () => {
    return new Promise((resolve, reject) => {

        let loggedInUser = localStorage.getItem("user");
        if (loggedInUser) {
            let parsedUser = JSON.parse(loggedInUser);
            let current_date = new Date();
            let user_date = new Date(Date.parse(parsedUser.date));

            const _MS_PER_HOUR = 1000 * 60 * 60;

            let timeDiff = Math.abs(current_date - user_date) / _MS_PER_HOUR;
            if (timeDiff < 1) {
                let user = {
                    id: parsedUser.id,
                    name: parsedUser.name,
                    username: parsedUser.username,
                    role: parsedUser.role,
                    isOwner: parsedUser.isOwner,
                    isAdmin: parsedUser.isAdmin,
                }
                resolve(user);
            }
            else {
                try {
                    axios.get("https://discord.com/api/users/@me/guilds/939623519237599264/member", {
                        headers: {
                            authorization: `${loggedInUser.tokenType} ${loggedInUser.accessToken}`
                        }
                    })
                        .then(response => {
                            if (response && response.data) {
                                var role = getUserRole(response.data.roles);

                                if (role) {
                                    let user = {
                                        tokenType: parsedUser.tokenType,
                                        accessToken: parsedUser.accessToken,
                                        id: parsedUser.id,
                                        name: parsedUser.name,
                                        username: parsedUser.username,
                                        role: role.name,
                                        isOwner: role.isOwner,
                                        isAdmin: role.isAdmin,
                                        date: new Date()
                                    }
                                    localStorage.setItem('user', JSON.stringify(user));
                                    resolve(user);
                                }
                                else
                                    reject("User does not have correct role to login");
                            }
                            else {
                                reject("No Response received");
                            }
                        }).catch(error => {
                            reject(error.message);
                        })
                } catch (err) {
                    reject(err.message);
                }
            }
        }
        else {
            reject("No logged in user");
        }
    });
}

function getUserRole(roles) {
    var role;
    var rolename = '';
    var isOwner = false;
    var isAdmin = false;
    if (roles) {
        if (roles.find(x => x === '941209882458202142')) {
            rolename = 'Owner';
            isOwner = true;
            isAdmin = true;
        }
        else if (roles.find(x => x === '939626462984699998')) {
            rolename = 'Co-Owner';
            isOwner = true;
            isAdmin = true;
        }
        else if (roles.find(x => x === '939664195190927360')) {
            rolename = 'Executive';
            isAdmin = true;
        }
        else if (roles.find(x => x === '988154314482663515')) {
            rolename = 'Manager';
            isAdmin = true;
        }
        /*else if (roles.find(x => x === '939665279988957325')) {
                rolename = 'Coordinator';
                isAdmin = true;
            }*/
        else if (roles.find(x => x === '1163756193530003456')) {
            rolename = 'Sheets Access';
            isAdmin = true;
        }
        else {
            return null;
        }
        role = {
            name: rolename,
            isOwner: isOwner,
            isAdmin: isAdmin
        };
    }

    return role;
}
/*
export const getDiscordUser = useCallback(async () => {
    let loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
        setUser(loggedInUser);
        let parsedUser = JSON.parse(loggedInUser);
        setUser(parsedUser.name);
    }
    else {
        setUser('unknown');
    }

    return loggedInUser;
});*/